<template>
  <div class="footer get-height">
    <v-btn
      type="button"
      color="danger--gradient"
      depressed
      round
      @click="cancelRide"
    >
      {{ $t(`${namespace}.cancelRide`) }}
    </v-btn>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'Footer',
  props: {
    ride: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      namespace: 'Views.NewWebCallPage.rideList.card'
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    cancelRide () {
      this.$emit('cancelRide')
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  align-items: center;
  background-color: #fff;
  border-top: 1px solid $gray-4;
  height: 83px;
  display: flex;
  justify-content: center;
  margin-top: 1px;
}
</style>
